<template>
  <van-popup v-model="show" round position="bottom" @close="$emit('close')">
    <div class="occupy_edit">
      <div class="occupy_edit_title">
        <div></div>
        <span>{{value.relName}}占用编辑</span>
        <i class="iconfont icon-icon-close" @click="$emit('close')"></i>
      </div>
      <div class="occupy_edit_content">
        <DsfMobileDateIntervalPicker v-model="dateValue" fromDirection="vertical" chooseType="datetime" :required="true" inputAlign="left">
        </DsfMobileDateIntervalPicker>
        <DsfMobileTextbox v-model="contacts" fromDirection="vertical" label="联系人" inputAlign="left">
        </DsfMobileTextbox>
        <DsfMobileTextbox v-model="phone" fromDirection="vertical" label="联系电话" inputAlign="left">
        </DsfMobileTextbox>
        <DsfMobileTextbox v-model="reason" fromDirection="vertical" label="占用原因" inputAlign="left">
        </DsfMobileTextbox>
      </div>
      <div class="tabs_btn_box">
        <div class="btn_cz" @click="$emit('close')">返回</div>
        <div class="btn_sure" @click="sumbit">确定</div>
      </div>
    </div>
  </van-popup>
</template>

<script>

export default {
  name: "DsfOccupyPopup",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default: () => {
        return {
          name: '',
          startDate: '',
          endDate: '',
          relName: '',
          id: ''
        }
      }
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value(newValue, oldValue) {
      if (newValue) {
        this.dateValue = {
          sdate: newValue.startDate,
          edate: newValue.endDate,
        }
        this.phone = newValue.phone;
        this.reason = newValue.reason;
        this.contacts = newValue.contacts;
      }
    },
  },
  data() {
    return {
      dateValue: {},
      phone: '',
      contacts: '',
      reason: ''
    }
  },
  methods: {
    sumbit() {
      let reg_phone = /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/;
      if (this.phone && !reg_phone.test(this.phone)) {
        dsf.layer.message('请输入正确手机号码')
        return
      }
      let url = '';
      let dataString = {};
      if (this.isEdit) {
        url = 'meta/persistData?id=' + this.value.id;
        dataString = {
          'resource_occupy.business': { text: '手动占用', value: this.value.relid },
          'resource_occupy.business_type': { text: '手动占用', value: '3' },
          'resource_occupy.contact_text': this.contacts,
          'resource_occupy.end_datetime': this.dateValue.edate,
          'resource_occupy.phone': this.phone,
          'resource_occupy.reason': this.reason,
          'resource_occupy.resource_occupy_id': this.value.occupyId,
          'resource_occupy.resource_text': this.value.relName,
          'resource_occupy.resource_type': { text: '地点', value: 'PLACE' },
          'resource_occupy.resource_value': this.value.id,
          'resource_occupy.start_datetime': this.dateValue.sdate,
          '_id': this.value.occupyId
        }
      } else {
        url = 'meta/persistData?resourceId=' + this.value.id + '&startTime=' + this.dateValue.sdate + '&endTime=' + this.dateValue.edate + '&resourceName=' + this.value.name
        dataString = {
          'resource_occupy.business': { text: '手动占用', value: '' },
          'resource_occupy.business_type': { text: '手动占用', value: '3' },
          'resource_occupy.contact_text': this.contacts,
          'resource_occupy.end_datetime': this.dateValue.edate,
          'resource_occupy.phone': this.phone,
          'resource_occupy.reason': this.reason,
          'resource_occupy.resource_text': this.value.relName,
          'resource_occupy.resource_type': { text: '地点', value: 'PLACE' },
          'resource_occupy.resource_value': this.value.id,
          'resource_occupy.start_datetime': this.dateValue.sdate,
        }
      }
      let data = {
        namespace: 'resource.occupy',
        pageName: 'manual',
        data: JSON.stringify(dataString)
      }
      this.$http.post(url, data).done(res => {
        if (res.success && res.state == 20000 && res.data) {
          this.$emit('submit')
        } else {
          dsf.layer.message(res.message, false);
        }
      }).error((err) => {
        dsf.layer.message(err.message || "出错了，请重试", false);
      })
        .always(() => {
        });
    }
  },
  created() {
  },
  mounted() {
  }
}
</script>

<style>
</style>